import React from "react";
import WalletPage from "./WalletPage";

export default function Links() {
  return (
    <WalletPage
      type="link"
      title="Links"
      subtitle="Processor links — set per-link charge %, settle in USDT"
      prefix="link"
      processorMode
    />
  );
}
